import axios, { AxiosInstance } from "axios";

// Base URL - Use API Gateway like all other services
const API_BASE_URL =
  import.meta.env.VITE_RIDER_API_URL || "http://localhost:8000/api";

class TelecallerService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: API_BASE_URL,
      timeout: 15000,
      headers: {
        "Content-Type": "application/json",
      },
    });

    this.api.interceptors.request.use((config) => {
      const token = localStorage.getItem("authToken");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        console.error(
          "Telecaller service error:",
          error.response?.data || error.message
        );
        return Promise.reject(error);
      }
    );
  }

  // Get all telecallers with filters
  async getTelecallers(params?: {
    page?: number;
    limit?: number;
    isActive?: boolean;
    city?: string;
    search?: string;
  }) {
    const response = await this.api.get("/riders/telecallers", { params });
    return response.data;
  }

  // Get telecaller by ID
  async getTelecallerById(id: string) {
    const response = await this.api.get(`/riders/telecallers/${id}`);
    return response.data;
  }

  // Create new telecaller
  async createTelecaller(data: {
    name: string;
    phone: string;
    email?: string;
    employeeId?: string;
    assignedCities: string[];
  }) {
    const response = await this.api.post("/riders/telecallers", data);
    return response.data;
  }

  // Update telecaller
  async updateTelecaller(
    id: string,
    data: {
      name?: string;
      phone?: string;
      email?: string;
      assignedCities?: string[];
    }
  ) {
    const response = await this.api.put(`/riders/telecallers/${id}`, data);
    return response.data;
  }

  // Deactivate telecaller
  async deactivateTelecaller(id: string) {
    const response = await this.api.put(`/riders/telecallers/${id}/deactivate`);
    return response.data;
  }

  // Get telecaller performance
  async getTelecallerPerformance(id: string) {
    const response = await this.api.get(
      `/riders/telecallers/${id}/performance`
    );
    return response.data;
  }

  // Update telecaller metrics
  async updateTelecallerMetrics(id: string) {
    const response = await this.api.post(
      `/riders/telecallers/${id}/update-metrics`
    );
    return response.data;
  }

  // Update all telecaller metrics
  async updateAllTelecallerMetrics() {
    const response = await this.api.post(
      "/riders/telecallers/metrics/update-all"
    );
    return response.data;
  }
}

export const telecallerService = new TelecallerService();
export default telecallerService;
